import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { UTResultsMapContainer } from '@ruby/modules/unit-train/submodules/ut-map/containers/ut-results-map/ut-results-map.container';

const routes: Routes = [
  { path: 'mapping', component: UTResultsMapContainer }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class UTMapRoutingModule {}
